import axios from 'axios'
import store from '../store/session'
import router from '../router'

/* 跨域设置 */
axios.interceptors.request.use(
	config => {
		var token = store.getters.getToken;
		var userInfo = store.getters.getUser;
		if(token){
			config.headers = {
				'Content-Type': 'application/json',
				'clientName': 'admin',
				'headerUserId': userInfo.id,
				'headerUserToken': token
			}
		}else{
			config.headers = {
				'Content-Type': 'application/json',
				'clientName': 'admin'
			}
		}
		return config
	},
	err => {
		return Promise.reject(err)
	}
)
axios.interceptors.response.use(
	response => {
		if (response.data.status == 501) {
			router.push({
				path: '/'
			})
		}
		return response
	},
	err => {
		return Promise.reject(err.response.data)
	}
)

export function get(url, data = {}) {
	url = this.API_URL + url;
		return new Promise((resolve, reject) => {
			axios.get(url, data)
				.then(response => {
					resolve(response.data)
				},
					err => {
						reject(err)
					}
				)
		}
	)
}

export function post(url, data = {}) {
	url = this.API_URL + url;
		return new Promise((resolve, reject) => {
			axios.post(url, data)
				.then(response => {
					resolve(response.data);

				},
					err => {
						alert(err.msg);
						if(err.status == 501){
							router.push({
								path: '/',
								query: { redirect: router.currentRoute.fullPath }
							})
						}
						reject(err)
					}
				)
		}
	)
}

export function postBase(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.post(url, data)
			.then(response => {
				resolve(response.data)
			},
				err => {
					reject(err)
				}
			)
	}
	)
}

export function postImage(url, data = {}, config) {
	url = this.API_URL + url;
	return new Promise((resolve, reject) => {
		axios.post(url, data, config)
			.then(response => {
				resolve(response.data)
			},
				err => {
					reject(err)
				}
			)
	}
	)
}
export function put(url, data = {}) {
	url = this.API_URL + url;
	return new Promise((resolve, reject) => {
		axios.put(url, data)
			.then(response => {
				resolve(response.data)
			}, err => {
				reject(err)
			})
	})
}
